import { sleep } from '@helpers/utils';
import * as React from 'react';
import { useFirstMountState } from 'react-use';
export function useApi(params) {
    const refAbortController = React.useRef();
    const isFirstMount = useFirstMountState();
    const [data, setData] = React.useState(params.initialData);
    const [status, setStatus] = React.useState('initial');
    const minTime = 500;
    const clear = () => {
        setData(undefined);
    };
    React.useEffect(() => {
        // Ignore first mount if initial data is supplied.
        if (isFirstMount && params.initialData) {
            return;
        }
        // Ignore if validate is supplied and returns false.
        if (params.validate && !params.validate()) {
            return;
        }
        // Setup abortable fetch.
        refAbortController.current = new AbortController();
        const signal = refAbortController.current.signal;
        // Trigger fetch with abort signal.
        doAsync(signal);
        return () => {
            // Abort pending request if re-fetching.
            refAbortController.current?.abort();
        };
        async function doAsync(signal) {
            setStatus('loading');
            const start = Date.now();
            const res = await fetch(params.url, {
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    Accept: 'application/json',
                },
                method: 'get',
                signal,
            });
            const resData = await res.json();
            const end = Date.now();
            const diff = end - start;
            /** Ensure at least 500ms is taken to return results to prevent loader flash */
            if (diff < minTime) {
                await sleep(minTime - diff);
            }
            setData(resData);
            setStatus('complete');
        }
    }, [params.url]);
    return { clear, data, status };
}
